export default __webpack_public_path__ + "static/media/banner.1625d88e.jpg";